import { Link } from 'react-router';
import { CreditCard } from 'lucide-react';
import { Button } from '@/shared/components/Button';
import styles from './ErrorPage.module.css';

export function SubscriptionBlockedPage() {
  return (
    <div className={styles.wrapper}>
      <CreditCard size={64} strokeWidth={1.5} className={styles.icon} />
      <h1 className={styles.code}>Assinatura</h1>
      <p className={styles.title}>Acesso bloqueado</p>
      <p className={styles.description}>
        Seu período de teste expirou ou sua assinatura foi cancelada.
        Assine um plano para continuar usando o Vapt Menu.
      </p>
      <Link to="/billing">
        <Button variant="primary">Ver planos e assinar</Button>
      </Link>
    </div>
  );
}
